import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import Competence from '../components/Competence';
import Solutions from '../components/Solutions';
import Process from '../components/Process';
import WhyFBS from '../components/WhyFBS';
import Realizations from '../components/Realizations';

const HomePage: React.FC = () => {
  const [solutions, setSolutions] = useState([]);
  const [realizations, setRealizations] = useState([]);

  useEffect(() => {
    fetch('/api/solutions')
      .then(res => res.json())
      .then(data => setSolutions(data))
      .catch(err => console.error('Error fetching solutions:', err));

    fetch('/api/realizations')
      .then(res => res.json())
      .then(data => setRealizations(data))
      .catch(err => console.error('Error fetching realizations:', err));
  }, []);

  return (
    <>
      <Hero />
      <Competence />
      <Solutions solutions={solutions} />
      <Process />
      <WhyFBS />
      <Realizations realizations={realizations} />
    </>
  );
};

export default HomePage;
